import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import I18n, { t } from "@/i18n-js/instance";
import { slugFromCommunityName } from "@/react/helpers/communityHelpers";
import { Form } from "@circle-react-uikit/Form";

export const CommunitySlugInput = () => {
  const { watch, setValue, clearErrors } = useFormContext();
  const communityName = watch("community[name]");
  const localeScope = "authentication_app.create_community";

  useEffect(() => {
    setValue("community[slug]", slugFromCommunityName(communityName));
    clearErrors("community[slug]");
  }, [communityName, setValue]);

  return (
    <Form.Item
      name="community[slug]"
      label={t(`${localeScope}.form.slug`)}
      hideDescription
      hideBorder
      rules={{
        required: I18n.t(`${localeScope}.form.errors.slug_required`),
      }}
      tooltipText={t("url_description_setup_custom_domain_later")}
    >
      <Form.Input suffix="circle.so" data-testid="community_slug" />
    </Form.Item>
  );
};
